import { Huskyrc } from "./models";

const emptyHuskyrc: Huskyrc = { hooks: {} };

export const huskyrcJson = (hooks: Huskyrc["hooks"]) => (
    config: Huskyrc | null = emptyHuskyrc,
): Huskyrc => ({
    ...(config || {}),
    hooks: { ...(config?.hooks || {}), ...hooks },
});
